const customStyles = {
  control: (base) => ({
    ...base,
    flexDirection: 'row-reverse',
    borderColor: 'var(--color-gp--grey3)',
    boxShadow: 'none',
    height: '56px',
    '&:hover': {
      outline: 'none',
    },
    '@media only screen and (min-width: 768px)': {
      ...base['@media only screen and (min-width: 768px)'],
      height: '48px',
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    position: 'absolute',
    right: 0,
    paddingRight: 16,
  }),
  valueContainer: (provided) => ({
    ...provided,
    overflow: 'visible',
    height: '100%',
    padding: '0px',
    cursor: 'text',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '0px 0px 0px 16px',
  }),
  menu: (base) => ({
    ...base,
    margin: '0px',
    boxShadow: '0px 3px 6px #0000003B',
    borderRadius: '4px',
  }),
  menuList: (base) => ({
    ...base,
    margin: '0px',
    maxHeight: '200px',
    /* width */
    '::-webkit-scrollbar': {
      width: '8px',
    },
    /* Track */
    '::-webkit-scrollbar-track': {
      boxShadow: 'none',
      borderRadius: 'none',
    },

    /* Handle */
    '::-webkit-scrollbar-thumb': {
      background: 'var(--color-gp--grey3)',
      borderRadius: '10px',
    },
    '@media only screen and (min-width: 768px)': {
      ...base['@media only screen and (min-width: 768px)'],
      maxHeight: '200px',
    },
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    fontFamily: 'Regular',
    padding: '10px 10px 10px 30px',
    color: 'var(--color-gp--grey6)',
    backgroundColor: isSelected
      ? 'var(--color-gp--grey2)'
      : isFocused
        ? 'var(--color-gp--grey1)'
        : undefined,
    ':active': {
      backgroundColor: 'var(--color-gp--grey2)',
    },
  }),
};

export default customStyles;
